import { useTranslation } from 'next-i18next';
import React, { useMemo } from 'react';

import Chat from '@/components/Icon/Chat';
import Email from '@/components/Icon/Email';
import Location from '@/components/Icon/Location';
import Title from '@/components/Title';

interface IList {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
}
const OlineReference = () => {
  const { t } = useTranslation('contactUs');

  const openIntercom = () => {
    if (window?.Intercom) {
      // Intercom 已初始化，调用其方法
      window?.Intercom?.('show');
      return true;
    }
    return false;
  };

  const list: IList[] = useMemo(
    () => [
      {
        icon: <Email />,
        title: t('邮箱地址'),
        description: t('邮箱'),
      },
      {
        icon: <Location />,
        title: t('美国地址-标题'),
        description: t('美国地址-详细地址'),
      },
      {
        icon: <Chat />,
        title: t('在线咨询'),
        description: (
          <span
            onClick={openIntercom}
            className="cursor-pointer text-[#453DEE]">
            {t('立即沟通')}
          </span>
        ),
      },
    ],
    [t],
  );

  return (
    <div className="">
      <Title theme="colorful">
        <span
          className="[&_strong]:inline"
          dangerouslySetInnerHTML={{ __html: t('slogan') }}
        />
      </Title>
      <div className="mt-6 flex flex-col space-y-6 lg:mx-0 lg:mt-12 lg:flex-row lg:space-x-4 lg:space-y-0 xl:mt-15 xl:space-x-6">
        {list.map(item => (
          <div
            key={item.title}
            className="flex w-full flex-col items-center justify-center space-y-3 rounded-3xl border-2 border-white/45 bg-gradient-to-t from-white/40 to-white/90 px-5 py-6 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] backdrop-blur lg:w-1/3 lg:space-y-4 lg:py-8 xl:space-y-5 xl:rounded-5xl xl:px-8 xl:py-10">
            <div
              style={{
                background:
                  'linear-gradient(94deg, rgba(156, 65, 199, 0.06) 0.44%, rgba(63, 100, 253, 0.06) 44.33%, rgba(2, 156, 255, 0.06) 97%)',
              }}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-wk-words-2 lg:h-15 lg:w-15 xl:h-[72px] xl:w-[72px]">
              {item.icon}
            </div>
            <h5 className="text-center text-[20px] font-bold lg:text-[24px] xl:text-[28px]">
              {item.title}
            </h5>
            <p className="text-center text-[16px] text-wk-words-2 xl:text-[20px]">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OlineReference;
